<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <cipafacil-vertical-navigation
        class="bg-white"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="verticalNavigation"
        [opened]="false">
        <!-- Navigation header hook -->
        <ng-container cipafacilVerticalNavigationContentHeader="">
            <!-- Logo -->
            <div [routerLink]="['/dashboard']" class="cursor-pointer flex items-start h-20 pl-6 pt-6">
                <img class="w-32" src="assets/images/logo/logo-cipa-white.png" alt="Logo image">
            </div>
        </ng-container>
    </cipafacil-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto items-center w-full min-w-0 bg-gray-200 dark:bg-card">

    <div class="fixed z-99 w-full shadow">

        <!-- Header -->
        <div class="flex flex-col flex-0 justify-center w-full overflow-hidden">
            <!-- Top bar -->
            <div class="relative flex flex-auto justify-center w-full px-4 md:px-8 bg-primary-900 border-b"
                 [class.safe-area-top]="isAndroid || isIos">
                <div class="flex items-center w-full h-16">
                    <!-- Logo -->
                    <ng-container *ngIf="!isScreenSmall">
                        <div [routerLink]="['/admin']" class="flex cursor-pointer items-center">
                            <img class="w-32" src="assets/images/logo/logo-cipa-inverse.png">
                        </div>

                        <cipafacil-horizontal-navigation
                            class="ml-8 dark bg-transparent"
                            [name]="'mainNavigation'"
                            [navigation]="horizontalNavigation"></cipafacil-horizontal-navigation>
                    </ng-container>
                    <!-- Navigation toggle button -->
                    <ng-container *ngIf="isScreenSmall">
                        <button *ngIf="isDashboard" mat-icon-button (click)="toggleNavigation('mainNavigation')">
                            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
                        </button>
                        <div *ngIf="!isDashboard" class="flex items-center">
                            <button (click)="back()" mat-icon-button>
                                <mat-icon class="icon-size-4.5" [svgIcon]="'awesome_solid:arrow-left'"></mat-icon>
                            </button>

                            <h2 class="text-xl font-medium text-blue-800 tracking-tight leading-7 my-0 truncate ml-2">{{title}}</h2>
                        </div>
                    </ng-container>

                    <div *ngIf="!isScreenSmall || (isScreenSmall && isDashboard)" class="flex items-center pl-2 ml-auto space-x-2">
                        <user-menu [dark]="true"></user-menu>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="ios-admin-content flex flex-auto justify-center bg-white w-full pt-16">
        <div class="flex flex-col flex-auto w-full pb-20 md:pb-0" [ngClass]="{'safe-area-top': isAndroid || isIos}">
            <router-outlet *ngIf="true"></router-outlet>
        </div>
    </div>

</div>
